module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "left",
    attrs: {
      "id": "prf"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }), _c('span', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9780062026361_004.png"
    }
  })])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062026361_epub_toc_r1.htm#prfa"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REFACE")])])]), _vm._v(" "), _c('h1', {
    staticClass: "subchapter"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062026361_epub_toc_r1.htm#prfa"
    }
  }, [_c('em', [_vm._v("by His Holiness the Dalai Lama")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDDHISM HAS EVOLVED DIFFERENTLY IN DIFFERENT TIMES")]), _vm._v(" and places and yet the essential Dharma remains the same. The Buddha’s prime concern was that all beings should find peace and freedom from suffering. His advice that we should try to help each other if we can and at least avoid doing one another harm remains relevant everywhere, reaching across the boundaries of nationality, language, religion and culture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the heart of the Buddha’s teaching lies the idea that the potential for awakening and perfection is present in every human being and that it is a matter of personal effort to realise that potential. The Buddha proclaimed that each individual is a master of his or her own destiny, highlighting the ability that each person holds to achieve enlightenment. In fulfilling this aim what we need is compassion and concern for others and not self-centredness. Whether you are a Buddhist or not, these are qualities that are worth cultivating.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In recent decades improved travel and communications facilities have made our world smaller. This has at the same time made it possible for many people in the West to become more aware of Buddhism. As a result we have seen a flowering of Buddhist traditions in new lands that has not only enabled students to discover different modes of practice, but also allowed "), _c('a', {
    attrs: {
      "id": "pagex"
    }
  }), _vm._v("Buddhist teachers themselves to get to know one another and share their experiences. As a young man in Tibet I myself had only very vague ideas of how the Dharma was practised elsewhere. In my long years as a refugee I have been fortunate to meet many other Buddhists. This has helped me greatly to improve my understanding of their traditions, while deepening my appreciation of other religious faiths too. I have found that extending our understanding of each other’s spiritual practices and traditions can be an enriching experience, because to do so increases our opportunities for mutual respect. Often we encounter things in another tradition that helps us better appreciate something in our own.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Joseph Goldstein has been a Dharma student and teacher for much of his adult life and is a founding member of the Insight Meditation Society. He is an example of a new kind of Buddhist that we find in the West these days. Rather than holding tightly to a single tradition, he has studied with an array of teachers, integrating aspects of several Buddhist lineages into his practice. There are historical precedents for such an approach. Buddhism has often been reinvigorated when a new synthesis has been created from existing traditions. Buddhist training, wherever it has evolved, consists of certain fundamental elements such as the practices of mindfulness, loving-kindness, compassion, nonattachment and wisdom. These common themes are what Joseph has focused on here in this aptly entitled book, One "), _c('em', [_vm._v("Dharma.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9780062026361_006.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALAI")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMA")]), _c('br'), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARCH")]), _vm._v(" 6, 2002")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21e8d4bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780062026361_epub_prf_r1.vue
// module id = 69
// module chunks = 0